module.exports = "<div class=\"c-accordion-list\">\n    <slot name=\"heading\"></slot>\n    <slot></slot>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./assets/_js/components/accordion-list/accordion-list.vhtml
// module id = 292
// module chunks = 0